import DayjsUtils from '@date-io/dayjs';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import SearchIcon from '@material-ui/icons/Search';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import dayjs from 'dayjs';
import React, { useEffect, useState } from "react";
import { useActions, useValues } from 'kea';
import CloseIcon from '@material-ui/icons/Close';
import InfoIcon from '@material-ui/icons/Info';

import vehiclelogic from 'src/store/vehicle';
import { minHistoryDate } from 'src/utils/constants';
import { Box, CircularProgress, Dialog, DialogActions, DialogTitle, IconButton, Link, Tooltip } from '@material-ui/core';

const useStyles = makeStyles({
	root: {
		minWidth: "100%",
		padding: '20px'
	}
});


export default function History({ vehicle }) {
	const classes = useStyles();

	const { history, historyloading } = useValues(vehiclelogic);
	const { fetchHistory, setHistory } = useActions(vehiclelogic);

	const [selectedDate, handleDateChange] = useState();
	const [open, setOpen] = useState(false);

	const [total, setTotals] = useState({ towed: { hrs: 0, kms: 0 }, driving: { hrs: 0, kms: 0 }, stopped: { hrs: 0, kms: 0 }, idle: { hrs: 0, kms: 0 } })

	useEffect(() => {
		let tmp = { towed: { hrs: 0, kms: 0 }, driving: { hrs: 0, kms: 0 }, stopped: { hrs: 0, kms: 0 }, idle: { hrs: 0, kms: 0 } };
		if (history.status) {
			// eslint-disable-next-line no-unused-expressions
			history?.status?.forEach((item) => {
				if (item.event === 'Towed') {
					tmp.towed.hrs += item.duration || 0;
					tmp.towed.kms += item.distance || 0;
				}
				if (item.event === 'Driving') {
					tmp.driving.hrs += item.duration || 0;
					tmp.driving.kms += item.distance || 0;
				}
				if (item.event === 'Stopped') {
					tmp.stopped.hrs += item.duration || 0;
				}
				if (item.event === 'Idle') {
					tmp.idle.hrs += item.duration || 0;
				}
			})
			setTotals(tmp);
		}
	}, [history])

	useEffect(() => {
		if (selectedDate) {
			fetchHistory({
				_id: vehicle._id,
				start: dayjs(selectedDate).startOf('day'),
				stop: dayjs(selectedDate).endOf('day')
			})
		}
	}, [selectedDate])

	const openHistory = () => {
		setOpen(true);
		setHistory([]);
	}
	const closeHistory = () => {
		setOpen(false);
	}

	return (
		<>
			<IconButton onClick={openHistory}
				size='small'
			>
				<InfoIcon />
				History
			</IconButton>
			<Dialog onClose={closeHistory} open={open} maxWidth="lg" fullWidth>
				<DialogTitle>
					Movement History - {` ${vehicle.name}`}
				</DialogTitle>
				<div className={classes.root} >
					<Box py="5px">
						<MuiPickersUtilsProvider utils={DayjsUtils}>
							<DatePicker
								autoOk
								ampm={false}
								variant="inline"
								format="DD/MM/YYYY"
								value={selectedDate}
								minDate={minHistoryDate}
								onChange={handleDateChange}
								disableFuture
								fullWidth
							/>
						</MuiPickersUtilsProvider>
					</Box>
					{
						historyloading && <Box style={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box>
					}
					<Box py="5px">
						{history?.status && <>
							<b>Towed:</b> {total.towed.hrs ? dayjs.duration(dayjs(0).diff(dayjs(total.towed.hrs) * 1000)).humanize() : `${total.towed.hrs} hour`} ({total.towed.kms / 1000} kms)<br />
							<b>Driving:</b> {total.driving.hrs ? dayjs.duration(dayjs(0).diff(dayjs(total.driving.hrs) * 1000)).humanize() : `${total.driving.hrs} hour`} ({total.driving.kms / 1000} kms)<br />
							<b>Stopped:</b> {total.stopped.hrs ? dayjs.duration(dayjs(0).diff(dayjs(total.stopped.hrs) * 1000)).humanize() : `${total.stopped.hrs} hour`}<br />
							<b>Idle:</b> {total.idle.hrs ? dayjs.duration(dayjs(0).diff(dayjs(total.idle.hrs) * 1000)).humanize() : `${total.idle.hrs} hour`}
						</>}
					</Box>
					<TableContainer style={{ maxHeight: '400px' }}>
						<Table stickyHeader size="small" aria-label="a dense table" >
							<TableBody>
								{
									history?.status?.map((row, index) => {
										return (
											<TableRow key={`inginition-address-${index}`}>
												<TableCell align="left">
													<b>{row.event}{row.stop && row.start && ` (${dayjs.duration(dayjs(row?.start?.position_timestamp).diff(dayjs(row?.stop?.position_timestamp))).humanize()})`}:</b><br />
													{dayjs(row.start_time).format('DD-MM-YYYY HH:mm:ss')}<br />
													From: <Link target="_blank" rel="noopener"
														href={`https://www.google.com/maps/place/${row.start.latitude},${row.start.longitude}`}>
														{row.start?.address}
													</Link><br />
													To: {row.stop && <Link target="_blank" rel="noopener"
														href={`https://www.google.com/maps/place/${row.stop.latitude},${row.stop.longitude}`}>
														{row.stop?.address}
													</Link>}{!row.stop ? 'Ongoing' : ''}
												</TableCell>
											</TableRow>
										)
									})
								}
							</TableBody>
						</Table>
					</TableContainer>
				</div>
				<DialogActions>
					< div style={{
						display: 'flex',
						width: '100%',
					}}>
						<Button onClick={closeHistory} color='secondary'>
							Close
						</Button>
					</div>
				</DialogActions>
			</Dialog>
		</>
	);
}
